"use client"

import { useState } from "react"

const CONTROLS = [
	{ symbol: "_", color: "#ffe600" },
	{ symbol: "□", color: "#ffe600" },
	{ symbol: "X", color: "#ff003c" },
] as const

export default function TitleBar() {
	const [hovered, setHovered] = useState<number | null>(null)
	const [jumpPos, setJumpPos] = useState({ left: "50%", top: "50%" })

	const handleEnter = (i: number) => {
		setHovered(i)
		setJumpPos({
			left: `${40 + Math.random() * 20}%`,
			top: `${30 + Math.random() * 40}%`,
		})
	}

	return (
		<div
			className="
				relative
				flex items-center justify-between
				px-2 py-1
				bg-gradient-to-r from-[#ff0080] to-[#220022]
				border-2 border-t-[#00f5ff] border-l-[#00f5ff] border-b-[#39ff14] border-r-[#39ff14]
			"
		>
			<div className="flex items-center gap-2">
				<span className="text-xl leading-none">🗑️</span>
				<span className="text-[#39ff14] font-bold text-lg tracking-wide [text-shadow:0_0_6px_#ff003c]">
					TRASHMAIL
				</span>
			</div>
			<div className="flex gap-1">
				{CONTROLS.map((control, i) => (
					<span
						key={control.symbol}
						onMouseEnter={() => handleEnter(i)}
						onMouseLeave={() => setHovered(null)}
						className={`
							w-5 h-5 grid place-items-center bg-[#0d0020]
							border-2 border-t-[#00f5ff] border-l-[#00f5ff] border-b-[#ff003c] border-r-[#ff003c]
							text-xs font-bold leading-none cursor-pointer
							${hovered === i ? "opacity-0" : ""}
						`}
						style={{ color: control.color }}
					>
						{control.symbol}
					</span>
				))}
			</div>
			{hovered !== null && (
				<span
					className="
						absolute -translate-x-1/2 -translate-y-1/2 z-[1000]
						pointer-events-none
						w-5 h-5 grid place-items-center bg-[#0d0020]
						border-2 border-t-[#00f5ff] border-l-[#00f5ff] border-b-[#ff003c] border-r-[#ff003c]
						text-xs font-bold leading-none
					"
					style={{ left: jumpPos.left, top: jumpPos.top, color: CONTROLS[hovered].color }}
				>
					{CONTROLS[hovered].symbol}
				</span>
			)}
		</div>
	)
}
